// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as MainRouteImport } from './routes/_main'
import { Route as AcessoNegadoRouteImport } from './routes/acesso-negado'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AguardandoRouteImport } from './routes/aguardando'
import { Route as CadastroRouteImport } from './routes/cadastro'
import { Route as EntrarRouteImport } from './routes/entrar'
import { Route as GuiasRouteImport } from './routes/guias'
import { Route as AuthenticatedFavoritosRouteImport } from './routes/_authenticated.favoritos'
import { Route as AuthenticatedMinhaContaRouteImport } from './routes/_authenticated/minha-conta'
import { Route as MainIndexRouteImport } from './routes/_main.index'
import { Route as MainContatoRouteImport } from './routes/_main.contato'
import { Route as MainPoliticaDePrivacidadeRouteImport } from './routes/_main.politica-de-privacidade'
import { Route as MainQueroSerFornecedorRouteImport } from './routes/_main/quero-ser-fornecedor'
import { Route as MainTermosDeUsoRouteImport } from './routes/_main.termos-de-uso'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminConfiguracoesRouteImport } from './routes/admin/configuracoes'
import { Route as AdminContatosRouteImport } from './routes/admin/contatos'
import { Route as AdminDenunciasRouteImport } from './routes/admin/denuncias'
import { Route as AdminEquipeRouteImport } from './routes/admin/equipe'
import { Route as AdminFornecedoresRouteImport } from './routes/admin/fornecedores'
import { Route as AdminImportarRouteImport } from './routes/admin/importar'
import { Route as AdminMidiasRouteImport } from './routes/admin/midias'
import { Route as AdminPaginasRouteImport } from './routes/admin/paginas'
import { Route as AdminReivindicacoesRouteImport } from './routes/admin/reivindicacoes'
import { Route as AdminRelatoriosRouteImport } from './routes/admin/relatorios'
import { Route as AdminSegmentosRouteImport } from './routes/admin/segmentos'
import { Route as AdminUsuariosRouteImport } from './routes/admin/usuarios'
import { Route as GuiasIndexRouteImport } from './routes/guias/index'
import { Route as GuiasCategoriaRouteImport } from './routes/guias/$categoria'
import { Route as AuthenticatedFornecedoresIndexRouteImport } from './routes/_authenticated.fornecedores.index'
import { Route as AuthenticatedFornecedoresIdRouteImport } from './routes/_authenticated.fornecedores.$id'
import { Route as AuthenticatedQueroAnunciarCadastroRouteImport } from './routes/_authenticated/quero-anunciar/cadastro'
import { Route as MainQueroAnunciarIndexRouteImport } from './routes/_main/quero-anunciar/index'
import { Route as GuiasCategoriaSlugRouteImport } from './routes/guias/$categoria.$slug'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const MainRoute = MainRouteImport.update({
            id: '/_main',getParentRoute: () => rootRouteImport
          })
const AcessoNegadoRoute = AcessoNegadoRouteImport.update({
            id: '/acesso-negado',path: '/acesso-negado',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AguardandoRoute = AguardandoRouteImport.update({
            id: '/aguardando',path: '/aguardando',getParentRoute: () => rootRouteImport
          })
const CadastroRoute = CadastroRouteImport.update({
            id: '/cadastro',path: '/cadastro',getParentRoute: () => rootRouteImport
          })
const EntrarRoute = EntrarRouteImport.update({
            id: '/entrar',path: '/entrar',getParentRoute: () => rootRouteImport
          })
const GuiasRoute = GuiasRouteImport.update({
            id: '/guias',path: '/guias',getParentRoute: () => rootRouteImport
          })
const AuthenticatedFavoritosRoute = AuthenticatedFavoritosRouteImport.update({
            id: '/favoritos',path: '/favoritos',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMinhaContaRoute = AuthenticatedMinhaContaRouteImport.update({
            id: '/minha-conta',path: '/minha-conta',getParentRoute: () => AuthenticatedRouteRoute
          })
const MainIndexRoute = MainIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainRoute
          })
const MainContatoRoute = MainContatoRouteImport.update({
            id: '/contato',path: '/contato',getParentRoute: () => MainRoute
          })
const MainPoliticaDePrivacidadeRoute = MainPoliticaDePrivacidadeRouteImport.update({
            id: '/politica-de-privacidade',path: '/politica-de-privacidade',getParentRoute: () => MainRoute
          })
const MainQueroSerFornecedorRoute = MainQueroSerFornecedorRouteImport.update({
            id: '/quero-ser-fornecedor',path: '/quero-ser-fornecedor',getParentRoute: () => MainRoute
          })
const MainTermosDeUsoRoute = MainTermosDeUsoRouteImport.update({
            id: '/termos-de-uso',path: '/termos-de-uso',getParentRoute: () => MainRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminConfiguracoesRoute = AdminConfiguracoesRouteImport.update({
            id: '/configuracoes',path: '/configuracoes',getParentRoute: () => AdminRoute
          })
const AdminContatosRoute = AdminContatosRouteImport.update({
            id: '/contatos',path: '/contatos',getParentRoute: () => AdminRoute
          })
const AdminDenunciasRoute = AdminDenunciasRouteImport.update({
            id: '/denuncias',path: '/denuncias',getParentRoute: () => AdminRoute
          })
const AdminEquipeRoute = AdminEquipeRouteImport.update({
            id: '/equipe',path: '/equipe',getParentRoute: () => AdminRoute
          })
const AdminFornecedoresRoute = AdminFornecedoresRouteImport.update({
            id: '/fornecedores',path: '/fornecedores',getParentRoute: () => AdminRoute
          })
const AdminImportarRoute = AdminImportarRouteImport.update({
            id: '/importar',path: '/importar',getParentRoute: () => AdminRoute
          })
const AdminMidiasRoute = AdminMidiasRouteImport.update({
            id: '/midias',path: '/midias',getParentRoute: () => AdminRoute
          })
const AdminPaginasRoute = AdminPaginasRouteImport.update({
            id: '/paginas',path: '/paginas',getParentRoute: () => AdminRoute
          })
const AdminReivindicacoesRoute = AdminReivindicacoesRouteImport.update({
            id: '/reivindicacoes',path: '/reivindicacoes',getParentRoute: () => AdminRoute
          })
const AdminRelatoriosRoute = AdminRelatoriosRouteImport.update({
            id: '/relatorios',path: '/relatorios',getParentRoute: () => AdminRoute
          })
const AdminSegmentosRoute = AdminSegmentosRouteImport.update({
            id: '/segmentos',path: '/segmentos',getParentRoute: () => AdminRoute
          })
const AdminUsuariosRoute = AdminUsuariosRouteImport.update({
            id: '/usuarios',path: '/usuarios',getParentRoute: () => AdminRoute
          })
const GuiasIndexRoute = GuiasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => GuiasRoute
          })
const GuiasCategoriaRoute = GuiasCategoriaRouteImport.update({
            id: '/$categoria',path: '/$categoria',getParentRoute: () => GuiasRoute
          })
const AuthenticatedFornecedoresIndexRoute = AuthenticatedFornecedoresIndexRouteImport.update({
            id: '/fornecedores/',path: '/fornecedores/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedFornecedoresIdRoute = AuthenticatedFornecedoresIdRouteImport.update({
            id: '/fornecedores/$id',path: '/fornecedores/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedQueroAnunciarCadastroRoute = AuthenticatedQueroAnunciarCadastroRouteImport.update({
            id: '/quero-anunciar/cadastro',path: '/quero-anunciar/cadastro',getParentRoute: () => AuthenticatedRouteRoute
          })
const MainQueroAnunciarIndexRoute = MainQueroAnunciarIndexRouteImport.update({
            id: '/quero-anunciar/',path: '/quero-anunciar/',getParentRoute: () => MainRoute
          })
const GuiasCategoriaSlugRoute = GuiasCategoriaSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => GuiasCategoriaRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedFavoritosRoute: AuthenticatedFavoritosRoute,AuthenticatedMinhaContaRoute: AuthenticatedMinhaContaRoute,AuthenticatedFornecedoresIdRoute: AuthenticatedFornecedoresIdRoute,AuthenticatedQueroAnunciarCadastroRoute: AuthenticatedQueroAnunciarCadastroRoute,AuthenticatedFornecedoresIndexRoute: AuthenticatedFornecedoresIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)




const MainRouteChildren = {
  MainContatoRoute: MainContatoRoute,MainPoliticaDePrivacidadeRoute: MainPoliticaDePrivacidadeRoute,MainQueroSerFornecedorRoute: MainQueroSerFornecedorRoute,MainTermosDeUsoRoute: MainTermosDeUsoRoute,MainIndexRoute: MainIndexRoute,MainQueroAnunciarIndexRoute: MainQueroAnunciarIndexRoute
}

const MainRouteWithChildren = MainRoute._addFileChildren(MainRouteChildren)




const AdminRouteChildren = {
  AdminConfiguracoesRoute: AdminConfiguracoesRoute,AdminContatosRoute: AdminContatosRoute,AdminDenunciasRoute: AdminDenunciasRoute,AdminEquipeRoute: AdminEquipeRoute,AdminFornecedoresRoute: AdminFornecedoresRoute,AdminImportarRoute: AdminImportarRoute,AdminMidiasRoute: AdminMidiasRoute,AdminPaginasRoute: AdminPaginasRoute,AdminReivindicacoesRoute: AdminReivindicacoesRoute,AdminRelatoriosRoute: AdminRelatoriosRoute,AdminSegmentosRoute: AdminSegmentosRoute,AdminUsuariosRoute: AdminUsuariosRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const GuiasCategoriaRouteChildren = {
  GuiasCategoriaSlugRoute: GuiasCategoriaSlugRoute
}

const GuiasCategoriaRouteWithChildren = GuiasCategoriaRoute._addFileChildren(GuiasCategoriaRouteChildren)



const GuiasRouteChildren = {
  GuiasCategoriaRoute: GuiasCategoriaRouteWithChildren,GuiasIndexRoute: GuiasIndexRoute
}

const GuiasRouteWithChildren = GuiasRoute._addFileChildren(GuiasRouteChildren)

const rootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,MainRoute: MainRouteWithChildren,AcessoNegadoRoute: AcessoNegadoRoute,AdminRoute: AdminRouteWithChildren,AguardandoRoute: AguardandoRoute,CadastroRoute: CadastroRoute,EntrarRoute: EntrarRoute,GuiasRoute: GuiasRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)